const settings = {
	title: "Innstillinger",
	locale: "Språk",
	rows_per_page: "Linjer per side",
};
export default settings;